import MainLayout from "../../Layouts/Main/main";
import { CreateModule } from "../factory";
import navigation from "./navigations.js";

const ProjectFinancing = ({ baseUrl }) =>
  CreateModule({ baseUrl, navigation, layout: MainLayout });

export default ProjectFinancing;
